import React from "react";
import { useSelector } from "react-redux";
export default function Index() {
  const { data, loading } = useSelector((state) => state.getOrgData);

  return (
    <div className="pl-[10px] w-full min-h-[76px] py-[10px]">
      <span className="text-2xl font-semibold text-[#171717] flex items-center gap-1 font-poppins ">
        Welcome back, {data?.message?.payload?.firstName}{" "}
        {data?.message?.payload?.lastName}
        <span className="text-[20px]">👋</span>
      </span>
      <span className="text-[#64748B] text-sm mt-[4px] font-poppins block">
        Here’s a quick look at your upcoming schedule, appointments, and
        activity.
      </span>
    </div>
  );
}
